import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderSharingNewMount = (data) => openPopupHelper({ popupName: popupNames.MOUNT_DIALOG, data });
